import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { parseDate } from '@internationalized/date';
import { selectDate, selectCustomerId } from '@pages/reporting-pages/shipment-stops/store/selectors';
import { setDate, setCustomerId } from '@pages/reporting-pages/shipment-stops/store/slice';
import { DatePicker } from 'components/date-picker/DatePicker';
import { TextField } from 'components/text-field/TextField';



const ParamsToolbar = () => {

	const date = useSelector(selectDate);
	const customerId = useSelector(selectCustomerId);

	const dispatch = useDispatch();
	const updateDate = (value: string) => dispatch(setDate(value));
	const updateCustomerId = (value: string | null) => dispatch(setCustomerId(value));

	return (
		<div className='reporting-params-toolbar shipment-stops-toolbar'>
			
			<DatePicker
				label='Datum'
				isRequired={true}
				value={date ? parseDate(date) : null}
				onChange={(date) => {
					if (date) {
						updateDate(date.toString());
					}
				}}
			/>

			<TextField
				label='ID zákazníka'
				maxLength={25}
				value={customerId}
				onChange={(value) => {
					if (!value || value.length === 0) {
						updateCustomerId(null);
					}
					updateCustomerId(value);
				}} />

		</div>
	)
};

export default memo(ParamsToolbar);